import { JobInterface } from '../../../interfaces/job.interface';

export class PickJob {
    public static readonly type = '[JobsPlacements] Pick a job';

    constructor(public job: JobInterface | null) {}
}
